export const palette = {
  accent: {
    main: '#2d5ebb', // Accent = highlight / brand
    light: '#ebf0f9',
    dark: '#1e429f',
    contrastText: '#ffffff',
  },

  background: {
    default: '#f7f9fc', // App background
    paper: '#ffffff', // Cards / modals
  },

  border: {
    default: '#d4d4d4', // Neutral border
  },

  common: {
    black: '#000000',
    white: '#ffffff',
    shim: '#00000066',
    white15: '#ffffff26',
    white10: 'rgba(255,255,255,0.10)',
    white18: 'rgba(255,255,255,0.18)',
    white20: 'rgba(255,255,255,0.20)',
    white25: 'rgba(255,255,255,0.25)',
    white30: 'rgba(255,255,255,0.30)',
    white35: 'rgba(255,255,255,0.35)',
    white40: 'rgba(255,255,255,0.40)',
    white50: 'rgba(255,255,255,0.50)',
    white55: 'rgba(255,255,255,0.55)',
    white60: 'rgba(255,255,255,0.60)',
    white70: 'rgba(255,255,255,0.70)',
    white75: 'rgba(255,255,255,0.75)',
    white80: 'rgba(255,255,255,0.80)',
  },

  error: {
    900: '#7a0c12', // Strong error
    main: '#d32029',
    light: '#fee0e0',
    dark: '#9e181f',
    icon: '#d32029',
    contrastText: '#ffffff',
    darkText: '#7a0c12',
    redAlpha10: 'rgba(220,38,38,0.10)',
  },

  gradient: {
    headerBlue: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 55%, #0369a1 100%)',
    headerBlueDark: 'linear-gradient(135deg, #1e429f 0%, #3b5bdb 100%)',
    headerNavy: 'linear-gradient(135deg, #1e3a5f 0%, #1565c0 55%, #0277bd 100%)',
    headerGreen: 'linear-gradient(135deg, #065f46 0%, #059669 100%)',
    headerAmber: 'linear-gradient(135deg, #b45309 0%, #d97706 100%)',
    headerRed: 'linear-gradient(135deg, #991b1b 0%, #dc2626 100%)',
    sectionBlue: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)',
    sectionPurple: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
  },

  grey: {
    50: '#fafafa',
    100: '#f2f2f2',
    200: '#eaeaea',
    300: '#cccccc',
    400: '#b3b3b3',
    500: '#9e9e9e', // FIXED
    600: '#78777b',
    700: '#4c4c4c',
    800: '#2f2f2f',
    900: '#1a1a1a',
  },

  info: {
    main: '#2d5ebb',
    light: '#e1e8f5',
    dark: '#1e429f',
    contrastText: '#ffffff',
    darkText: '#1e293b',
    lightBlue: '#90caf9',
  },

  icon: {
    dark: '#222222',
    default: '#4c4c4c', // Icons on light bg
    hover: '#2d5ebb',
    stroke: '#78777b',
  },

  other: {
    partner: '#2d5ebb',
    backdrop: '#00000066',
    background: '#f7f9fc',
    backgroundContrastText: '#222222',
    body: '#ffffff',
    border: '#d4d4d4',
    caution: '#a9670c',
    cookieBanner: '#ffffff',
    divider: '#e0e0e0',
    genesysChatBg: '#2853a4',
    genesysChatIcon: '#ffffff',
    tooltip: '#323232',
    tooltipDark: '#ffffff',
    footerBackground: '#f2f2f2',
    footerTextLink: '#2d5ebb',
    footerTextPrimary: '#222222',
    footerTextSecondary: '#4c4c4c',
    headerBackground: '#ffffff',
  },

  primary: {
    main: '#2d5ebb',
    light: '#ebf0f9',
    dark: '#1e429f',
    contrastText: '#ffffff',
    darkText: '#1e293b',
    background: '#f7f9fc',
    border: '#96aedd',
    blueAlpha04: 'rgba(30,66,159,0.04)',
    blueAlpha03: 'rgba(37,99,235,0.03)',
  },

  secondary: {
    main: '#145556',
    light: '#e6f2f2',
    dark: '#0f4243',
    contrastText: '#ffffff',
    darkText: '#0f4243',
    background: '#f0f4f7',
    border: '#89aaaa',
  },

  shadow: {
    primary: 'rgba(0,0,0,0.25)', // Primary shadow
    light: 'rgba(0,0,0,0.08)', // Light shadow for cards
    medium: 'rgba(0,0,0,0.1)', // Medium shadow
    strong: 'rgba(0,0,0,0.12)', // Stronger shadow for hover states
    dark: 'rgba(0,0,0,0.15)', // Dark shadow for elevated elements
    overlay: 'rgba(0, 0, 0, 0.5)', // Overlay/backdrop shadow
  },

  showcase: {
    color: '#44444426',
  },

  success: {
    50: '#f0fdf4',
    100: '#dcfce7',
    400: '#4ade80',
    700: '#15803d',
    800: '#166534',
    main: '#008a00',
    light: '#dffed8',
    dark: '#006a00',
    contrastText: '#ffffff',
    darkText: '#14532d',
    complete: '#16a34a',
    green: '#4ade80',
    greenAlpha25: 'rgba(74,222,128,0.25)',
    greenAlpha40: 'rgba(74,222,128,0.40)',
    mint: '#6ee7b7',
    tealAlpha30: 'rgba(16,185,129,0.30)',
    tealAlpha60: 'rgba(16,185,129,0.60)',
  },

  text: {
    primary: '#222222',
    secondary: '#4c4c4c',
    tertiary: '#6f6e72',
    link: '#2d5ebb',
    hover: '#1e429f',
    disabled: '#9e9e9e',
  },

  warning: {
    50: '#fff7ed',
    main: '#ff9800',
    light: '#fdf1d9',
    dark: '#a36200',
    contrastText: '#ffffff',
    darkText: '#7c2d12',
    accent: '#ffd43b',
    accentAlpha20: 'rgba(255,212,59,0.20)',
    accentAlpha25: 'rgba(255,212,59,0.25)',
    accentAlpha40: 'rgba(255,212,59,0.40)',
    accentAlpha50: 'rgba(255,212,59,0.50)',
    amberDark: '#b45309',
    amber: '#d97706',
    amberAlpha30: 'rgba(245,158,11,0.30)',
    amberAlpha60: 'rgba(245,158,11,0.60)',
  },

  actions: {
    disabledBg: '#eaeaea',
    disabledText: '#9e9e9e',
  },

  sidebar: {
    background: '#1e3a8a',
    text: '#ffffff',
    textTransparent: 'rgba(255,255,255,0.72)',
    subItemText: '#c7d2fe',
    hoverBg: 'rgba(255,255,255,0.13)',
    buttonBg: '#1a3580',
    buttonHoverBg: '#2563eb',
    border: 'rgba(255,255,255,0.15)',
    shadow: 'rgba(0,0,0,0.35)',
    shadowHover: 'rgba(0,0,0,0.45)',
  },

  notFound: {
    background: '#f9f9f9',
    text: '#6b7280',
  },
};

export type Palette = typeof palette;
